<template>
    <div class="videosCom reveal">
        <!-- other content -->
        <div class="sectionTitle black fsTitle stLeft">
            <span class="stLine reveal"></span>
            <splitter :content="localize(sectionData.title)"></splitter>                
        </div>

        <!-- isMobile= {{isMobile}} -->
        <div class="videosScroller" :style="getCountStyle()">
            <ul class="vidItems" :style="getCountStyle()" ref="vidItems1">
                <li class="vidItem"                     
                    @click="startVideo(index)"
                    v-for="(item, index) in sectionData.items"  
                    :key="index"
                    :style="getStyleIndex(index)">
                    
                    <div class="vidBox" >
                        <div class="embed-container">
                            <iframe
                                v-if="index==selectedIndex"
                                height="100%"
                                :src="item.vimeo+'?autoplay=1&controls=true'"
                                frameborder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen
                            ></iframe>
                            <img :src="item.vimeoImg" >
                        </div>
                     </div>
                </li>          
            </ul>
        </div>

        <div class="vmPager">
            <sidepager
                @item-change = "onPagerChange"
                :skinMode="1"
                :itemIndex="selectedIndex"
                :itemsPerPage="1"
                :items="sectionData.items">
            </sidepager>
        </div>

    </div>
</template>



<style scoped>
    .vmPager
    {
        position: absolute;
        top: calc(100vh - 50px);
        left: 50%;
        width: 200px;
        height: 50px;
        display: block;        
        text-align: center;
    }
    .videosCom
    {
        width:100vw;
        height: 100vh;
        position: relative;
    }
    .videosScroller
    {
        position: absolute;
        top: calc(50% + 65px);
        transform: translateY(-50%);
        clear: both;width: 100%;height: auto;
        overflow-x:scroll;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
    .videosScroller::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }
    .videosScroller .vidItems
    {
        height: auto;
        width:calc(50px + (70vw + 50px)*var(--itemscount));
        list-style: none;  
        display: flex;
        justify-items: center;
        align-items: top;
        
    }
    .videosScroller .vidItems .vidItem
    {
        display: inline-block;
        opacity: 1;
        cursor: pointer;        
        overflow: hidden;
        scroll-snap-align: start;
        scroll-snap-stop: normal;
        padding-left: 50px;
        /* border: solid 2px red; */
        
    }
    .videosScroller .vidItems .vidItem .vidBox
    {
        /* background-color: #202020; */
        /* multiply the height by 1.78 define by the screen height */
        /* height: 70vh;width: 124vh;  */

        /* define by the screen width */
        width: 60vw;
        height: calc(60vw / 1.78);

        /* border-radius: 50px 50px 50px 50px; */
        overflow: hidden;
        position: relative;
        clip-path: inset(4px);
    }    
/*     .videosScroller .vidItems .vidItem .vidBox video
    {
        width: 70vw;
        height: calc(70vw / 1.78);

        position: relative;
        left: 0;
        top: 0;
        opacity: 1;
    }    
 */
    .embed-container {
        position: relative;
        padding-bottom: 56.25%;
        height: 0;
        overflow: hidden;
        max-width: 100%;
    }

    .embed-container iframe,
    .embed-container object,
    .embed-container embed {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 100;
    }

    .embed-container img
    {
        height: auto;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;
    }


    @media (min-width: 850px) { 
    }

    @media (max-width: 850px) { 
        .videosCom
        {
            height: auto;
            padding-bottom: 100px;
        }
        .videosCom .sectionTitle
        {
            position: initial;
            padding-top: 100px;  
        }
        .videosScroller {
            position: relative;
            transform: none;
            top: 20px;
            overflow-x:visible;
            overflow-y:visible;
        }        
        .videosScroller .vidItems
        {
            width: 100vw;
            margin: auto;
            display: block;
        }        
        .videosScroller .vidItems .vidItem
        {
            padding: 20px 0px;
            margin: auto;
            width: 100vw;            
            display: block;
        }
        .videosScroller .vidItems .vidItem .vidBox{
            width: 90vw;
            height: calc(90vw / 1.78);
            margin: auto;
        }  
        .vmPager
        {
            display: none;
        }
    }    
    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {
    }    

</style>

<script>
import { mapActions, mapState } from "vuex";
import sidepager from "@/views/com/sidepager.vue";
import splitter from "@/views/com/splitter.vue";
import { splitLines,isMobileScreen }         from "@/utils";

export default 
{
    components: { sidepager,splitter },
    data()
    {
        return{
            items:[],
            secIndex:1,
            selectedIndex:-1,
            elementTitle:'',
            elementDesc:'',            
            maxTextHeight:0,
            intChanger:Object,
            isAutoChanging:false,
            styles:[]
        }
    },
    props:
    {
        sectionDataIndex:Number,
        sectionScrollProg:Object
    },
    mounted()
    {
        let vm = this;
        vm.items = this.sectionData.items;
    },
    destroyed() {
        
    },
    computed: {
        ...mapState(["xSelectedPlatform","siteData","siteDataReady","siteVisibleSection"]),
        isMobile()
        {
            return isMobileScreen();
        },
        sectionData()
        {
            return this.siteData.SECTIONS[this.sectionDataIndex];
        }
    },
    watch: {
        //sectionScrollProg
        '$store.state.sectionScrollProg': function() {
            //alert("updatung");
            //alert(this.sectionDataIndex);
            if(this.sectionScrollProg.index==this.sectionDataIndex)
            {
                //this.updateStyles();
            }
        },
      '$store.state.siteVisibleSection': function() 
      {
        var vm=this;        
        let _siteVisibleSection = this.$store.state.siteVisibleSection;        
        if(_siteVisibleSection==this.sectionDataIndex+1){
            //this.startVideo(0);
            //start the timer
            if(isMobileScreen()==false){
                //vm.startAutoChange();
            }
        }else
        {
            //vm.stopAutoChange();
            //this.stopAllVideos();
        }
      }
    },
    methods:
    {
        onPagerChange(index)
        {
            this.startVideo(index);
        },
        //add navigation buttons
        getPosterUrl(index){
            return "content/mguide/video/poster1.png";
        },
        getVideoUrl(index){
            return "content/mguide/video/tv_video_1.mp4";
        },
        startVideo(index)
        {
            //move the scroll and start the video
            //this.playVideo(index);
            this.selectedIndex = index;
            if(isMobileScreen()==false)
            {
                this.scrollToElement();
            }
        },
        stopAllVideos()
        {
            let videoElements = this.$el.querySelectorAll("video");
            for(var i=0;i<videoElements.length;i++){
                let vid = videoElements[i];
                vid.pause();
            }
        },
        playVideo(index)
        {
            let videoElements = this.$el.querySelectorAll("video");
            for(var i=0;i<videoElements.length;i++){
                let vid = videoElements[i];
                if(i==index){
                    vid.play();
                }else{
                    vid.pause();//pause the other videos
                }
            }
        },
        isVideoPlaying(index)
        {
            let videoElement = this.$el.querySelectorAll("video")[index];
            if(videoElement.currentTime > 0 && 
                !videoElement.paused && 
                !videoElement.ended && 
                videoElement.readyState > 2)
            {
                return true;
            }
            return false;
        },
        
        getStyleIndex(index){
            return "--index:"+index;
        },
        getCountStyle(){
            return "--itemscount:"+this.items.length;
        },
        moveToNextImage()
        {
            if(!this.isAutoChanging){
                return false;
            }
            var vm=this;
            let newIndex = vm.selectedIndex+1;
            if(newIndex>vm.sectionData.items.length-1){
                newIndex=0;                    
            }
            vm.setItem(newIndex,true);                
        },
        checkScrollPosition() 
        {
            var vm=this;
            let scroller = vm.$refs.bnImgScroll1;
            let scrX = scroller.offsetLeft;
            let scrolledX = scroller.scrollLeft;
            
            var reveals = scroller.querySelectorAll(".bnImgItem");
            for (var i = 0; i < reveals.length; i++) 
            {
                //find the element to highligt 
                //console.log("__scrolledX="+scrolledX);
                //console.log("(scrolledX+scrX) ="+scrolledX+"+"+scrX+" === "+reveals[i].offsetLeft);
                //if((scrolledX+scrX)==reveals[i].offsetLeft){
                if((scrolledX)==reveals[i].offsetLeft){
                    //alert("change from scroller");
                    vm.setItem(i,false);               
                    //console.log("[SELECTED !] vm.selectedIndex="+vm.selectedIndex);
                }
            }
        },
        scrollToElement()
        {
            let scrollToElement = this.$el.getElementsByClassName("vidItem")[this.selectedIndex];
            scrollToElement.scrollIntoView(
            { 
                behavior: 'smooth',
                inline:'center',
                block:'nearest' }
            );
            //if(isMobileScreen()){
        }
    }
};
</script>

